import axios from 'axios'
import SecureLS from 'secure-ls'

const secureLs = new SecureLS()

const api = axios.create({
  timeout: 120000,
  baseURL: process.env.REACT_APP_API_USER_URL,
})

export const setAuthorizationHeader = ({ email, password, token, isLoggedIn, company, id }) => {
  if (isLoggedIn) {
    let authorizationHeaderValue
    if (token) {
      authorizationHeaderValue = `Bearer ${token}`
    } else {
      authorizationHeaderValue = `Basic ${btoa(email + ':' + password)}`
    }
    api.defaults.headers['Authorization'] = authorizationHeaderValue
    api.defaults.headers['company'] = company
    api.defaults.headers['id'] = id
  } else {
    delete api.defaults.headers['Authorization']
  }
}

export const signup = (body) => {
  return api.post('/api/1.0/users', body)
}

export const activate = (token) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.post('/api/1.0/users/token/' + token)
}

export const login = (creds) => {
  return api.post('/api/1.0/auth', { ...creds })
}

export const logout = () => {
  return api.post('/api/1.0/logout')
}

export const changeLanguage = (language) => {
  api.defaults.headers['accept-language'] = language
}

export const getUsers = (page = 0, size = 10) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.get(`/api/1.0/users?page=${page}&size=${size}`)
}

export const getUser = (id) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.get(`/api/1.0/user/${id}`)
}

export const updateUser = (id, body) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.put(`/api/1.0/user/${id}`, body)
}

export const deleteUser = (id) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.delete(`/api/1.0/user/${id}`)
}

export const requestReset = (email) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.post('/api/1.0/user/password', { email, whiteLabel: 'SemParar' })
}

export const putPassword = async (body) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return await api.put('/api/1.0/user/password', body)
}

export const putChangePassword = (idUser, body) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.put('/api/1.0/user/change/password/' + idUser, body)
}

export const postProfileImage = async (file) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return new Promise((resolve, reject) => {
    if (file) {
      const formData = new FormData()
      formData.append('profilePhoto', file[0])
      api.defaults.headers['Content-Type'] = 'multipart/form-data'
      api.post('/api/1.0/images', formData).then((responseFile) => {
        delete api.defaults.headers['Content-Type']
        resolve(responseFile)
      })
    }
  })
}

export const getProfileImage = () => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.get('/api/1.0/images')
}

export const blockUser = (id, block) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.post(`/api/1.0/user/${id}/block`, { block })
}

export const approveUser = (id) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.post(`/api/1.0/user/${id}/reviewed`)
}
